import { useState } from 'react';

import { identify } from '@farmersdog/analytics';
import { Input, Button, FormControl, Text } from '@farmersdog/corgi-x';
import { Check } from '@farmersdog/corgi-x/icons';

import { isValidEmail } from '../../utils/isValidEmail';

import styles from './NewsletterForm.css';

import type { ChangeEvent, FormEvent } from 'react';

export function NewsletterForm() {
  const [formState, setState] = useState({
    email: '',
    isSubmitting: false,
    submitted: false,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setState(state => ({ ...state, email: e.target.value }));
  };

  const handleSubmit = (e: FormEvent) => {
    const { email } = formState;
    e.preventDefault();
    if (formState.isSubmitting) {
      return;
    }

    if (!isValidEmail(email)) {
      return;
    }

    setState(prevFormState => ({ ...prevFormState, isSubmitting: true }));
    // We subscribe emails just by identifying the user via e-mail
    identify(undefined, { email });
    // Add visual feedback that the form has been submitted
    setState(state => ({ ...state, isSubmitting: false, submitted: true }));
    return;
  };

  return (
    <form name="NewsletterForm" onSubmit={handleSubmit}>
      <FormControl
        aria-live="polite"
        message={
          formState.submitted && (
            <Text color="white" variant="heading-16" as="span">
              <Check aria-label="check" baseColor="White" size={12} />{' '}
              Subscribed!
            </Text>
          )
        }
      >
        <div className={styles.elements}>
          <Input
            label="Email"
            name="email"
            aria-label="Email address"
            value={formState.email}
            type="email"
            onChange={handleChange}
            autoComplete="email"
          />
          <Button
            variant="primary"
            disabled={formState.isSubmitting || !isValidEmail(formState.email)}
            type="submit"
            className={styles.button}
          >
            Submit
          </Button>
        </div>
      </FormControl>
    </form>
  );
}
